<template>
    <component :is="view" />
</template>

<script>
    import Vue from 'vue';

    export default Vue.component('CustomRouterView', {
        props: {
            routeConfig: {
                type: Object,
                required: true,
            },
        },
        computed: {
            view() {
                return this.routeConfig[this.$route.name];
            },
        },
    });
</script>
